module.exports = __webpack_public_path__ + "media/images/favicons/favicon-e0ebb11a111c4876c62d719f67d6562c.ico";